export default {
  meta: {
    title: '机会点详情页',
    url: '/expandstore/chancepointdetail'
  },
};
